export function contractsVersion(): string {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const packageJson = require('../../package.json') as { version?: string };
  if (!packageJson.version) {
    throw new Error('No version in package.json');
  }
  return packageJson.version;
}
